












import { Component, Vue, Prop } from 'vue-property-decorator';
import { NavigationSection } from '@/types/types';

@Component({})
export default class NavBarNavigation extends Vue {
  @Prop({ required: true }) public sections!: NavigationSection[];
}
